import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "@/lib/api";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    http.get(`/blog/posts/${slug}`).then(({ data }) => setPost(data)).catch(() => setMissing(true));
  }, [slug]);

  return (
    <div data-testid="blog-post" className="min-h-screen bg-app text-app">
      <Header />
      <section className="pt-32 pb-16 max-w-3xl mx-auto px-6">
        <Link to="/blog" className="inline-flex items-center gap-1.5 text-xs uppercase tracking-widest text-app-muted hover:text-[#C9A961] mb-6">
          <ArrowLeft className="w-3 h-3" /> All articles
        </Link>
        {missing && <div className="text-app-muted">Article not found.</div>}
        {post && (
          <article>
            {post.cover_url && (
              <div className="rounded-2xl overflow-hidden mb-8 aspect-[16/8] bg-slate-900/40">
                <img src={post.cover_url.startsWith("http") ? post.cover_url : `${process.env.REACT_APP_BACKEND_URL}${post.cover_url}`} alt={post.title} className="w-full h-full object-cover" />
              </div>
            )}
            <div className="text-[11px] uppercase tracking-widest text-[#C9A961] font-semibold mb-3">{post.category}</div>
            <h1 className="font-serif text-4xl sm:text-5xl mb-4">{post.title}</h1>
            <div className="text-xs text-app-muted mb-8">
              {new Date(post.created_at).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
              {post.author_email && ` · ${post.author_email}`}
            </div>
            <div data-testid="blog-body" className="prose prose-slate max-w-none text-app whitespace-pre-wrap leading-relaxed text-[15px]">
              {post.body}
            </div>
          </article>
        )}
      </section>
    </div>
  );
}
